<script>
import { apiOrganUserPermissionAppBindPageList, apiOrganUserPermissionAppUnbind } from '@/api/manage'
import AddApplication from './components/addApplication.vue'
import AuthManage from './components/authManage.vue'
export default {
  name: 'ApplicationAuth',
  components: { AddApplication, AuthManage },
  props: {
    orgUserUuid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      authVisible: false,
      tableData: [],
      total: 0,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      moduleDataList: []
    }
  },
  computed: {},
  watch: {
    roleUuid: {
      handler(val) {
        if (val) {
          this.getList()
        }
      }
    }
  },
  created() {
    if (this.orgUserUuid) {
      this.getList()
    }
  },
  methods: {
    async getList(state) {
      try {
        this.loading = true
        if (state !== 'page') this.page.pageNum = 1
        const { data } = await apiOrganUserPermissionAppBindPageList({
          orgUserUuid: this.orgUserUuid
        })
        this.tableData = data
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    async removeAppRole({ appUuid, appName }) {
      const load = this.$load()
      try {
        await this.$confirm(`是否移除：${appName}`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const res = await apiOrganUserPermissionAppUnbind({
          appUuidList: [appUuid],
          orgUserUuid: this.orgUserUuid
        })
        this.$message.success(res.msg)
        await this.getList('page')
      } catch (e) {

      } finally {
        load.close()
      }
    },
    setAuthManage({ moduleCode, appUuid }) {
      // 权限管理
      this.moduleDataList = [{ appUuid, moduleCode }]
      this.authVisible = true
    },
    selectApplication(val) {
      // table选择事件
      this.moduleDataList = val.map(i => {
        return {
          appUuid: i.appUuid,
          moduleCode: i.moduleCode,
          appName: i.appName,
          moduleCodeList: [],
          roleData: []
        }
      })
    },
    batchAuthManage() {
      // 批量权限管理
      if (Array.isArray(this.moduleDataList) && this.moduleDataList.length) {
        this.authVisible = true
      } else {
        this.$message.error('请选择应用')
      }
    },
    submitAuthManage() {
      this.moduleDataList = []
      this.getList('page')
    }
  }
}
</script>

<template>
  <div class="app-auth">
    <div class="auth-operation">
      <el-button v-permission="['112030201101204']" type="primary" @click="batchAuthManage">批量权限管理</el-button>
      <el-button v-permission="['112030201101205']" type="primary" @click="()=>{visible = true}">添加应用</el-button>
    </div>
    <div class="app-table-data">
      <el-table class="app-table-data-table" :data="tableData" height="400px" @selection-change="selectApplication">
        <el-table-column type="selection" width="70" />
        <el-table-column type="index" width="70" label="序号" />
        <el-table-column label="应用名称" min-width="120" prop="appName" />
        <el-table-column label="应用描述" min-width="150" prop="appDescription" />
        <el-table-column label="操作" width="150">
          <template #default="{ row }">
            <el-button v-if="row.moduleCode" type="text" @click="setAuthManage(row)">权限管理</el-button>
            <el-button v-if="row.readOnly === 0" type="text" @click="removeAppRole(row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--    <pagination-->
    <!--      :background="false"-->
    <!--      :layout="'total, sizes, prev, pager, next, jumper'"-->
    <!--      :limit.sync="page.pageSize"-->
    <!--      :page.sync="page.pageNum"-->
    <!--      :total="total"-->
    <!--      @pagination="getList('page')"-->
    <!--    />-->
    <add-application v-model="visible" :org-user-uuid="orgUserUuid" @submit="getList()" />
    <auth-manage v-model="authVisible" :org-user-uuid="orgUserUuid" :module-data="moduleDataList" @submit="submitAuthManage" />
  </div>
</template>

<style scoped lang="scss">
.app-auth{
  flex: 1;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  .auth-operation{
    position: absolute;
    top: -53px;
    right: 0;
  }
  .app-table-data{
    flex: 1;
    height: 100% !important;
    .app-table-data-table{
      height: 100% !important;
    }
  }
}
</style>
